
const html = `
<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">
<html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml"
    xmlns:o="urn:schemas-microsoft-com:office:office">

<head>
    <meta http-equiv="Content-Type" content="text/html; charset=utf-8">
    <meta http-equiv="X-UA-Compatible" content="IE=edge">
    <meta name="format-detection" content="telephone=no">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Convie Qazando Tools</title>
    <style type="text/css" emogrify="no">
        #outlook a {
            padding: 0;
        }

        .ExternalClass {
            width: 100%;
        }

        .ExternalClass,
        .ExternalClass p,
        .ExternalClass span,
        .ExternalClass font,
        .ExternalClass td,
        .ExternalClass div {
            line-height: 100%;
        }

        table td {
            border-collapse: collapse;
            mso-line-height-rule: exactly;
        }

        .editable.image {
            font-size: 0 !important;
            line-height: 0 !important;
        }

        .nl2go_preheader {
            display: none !important;
            mso-hide: all !important;
            mso-line-height-rule: exactly;
            visibility: hidden !important;
            line-height: 0px !important;
            font-size: 0px !important;
        }

        body {
            width: 100% !important;
            -webkit-text-size-adjust: 100%;
            -ms-text-size-adjust: 100%;
            margin: 0;
            padding: 0;
        }

        img {
            outline: none;
            text-decoration: none;
            -ms-interpolation-mode: bicubic;
        }
        a img {
            border: none;
        }

        table {
            border-collapse: collapse;
            mso-table-lspace: 0pt;
            mso-table-rspace: 0pt;
        }

        th {
            font-weight: normal;
            text-align: left;
        }

        *[class="gmail-fix"] {
            display: none !important;
        }
    </style>
    <style type="text/css" emogrify="no">
        @media (max-width: 600px) {
            .gmx-killpill {
                content: ' \u03D1';
            }
        }
    </style>
    <style type="text/css" emogrify="no">
        @media (max-width: 600px) {
            .gmx-killpill {
                content: ' \u03D1';
            }

            .r0-o {
                border-style: solid !important;
                margin: 0 auto 0 auto !important;
                width: 100% !important
            }

            .r1-i {
                background-color: transparent !important
            }

            .r2-c {
                box-sizing: border-box !important;
                text-align: center !important;
                valign: top !important;
                width: 320px !important
            }

            .r3-o {
                border-style: solid !important;
                margin: 0 auto 0 auto !important;
                width: 320px !important
            }

            .r4-i {
                padding-bottom: 5px !important;
                padding-top: 5px !important
            }

            .r5-c {
                box-sizing: border-box !important;
                display: block !important;
                valign: top !important;
                width: 100% !important
            }

            .r6-o {
                border-style: solid !important;
                width: 100% !important
            }

            .r7-i {
                padding-left: 10px !important;
                padding-right: 10px !important;
                padding-top: 20px !important;
                text-align: center !important
            }

            .r8-i {
                background-color: #7d00ff !important
            }

            .r9-c {
                box-sizing: border-box !important;
                text-align: center !important;
                valign: top !important;
                width: 100% !important
            }

            .r10-i {
                background-color: #ffffff !important;
                padding-left: 15px !important;
                padding-right: 15px !important;
                padding-top: 35px !important
            }

            .r11-i {
                padding-bottom: 15px !important;
                padding-top: 15px !important
            }

            .r12-o {
                border-style: solid !important;
                margin: 0 auto 0 0 !important;
                margin-bottom: 0px !important;
                margin-top: 0px !important;
                width: 100% !important
            }

            .r13-i {
                text-align: left !important
            }

            .r14-o {
                border-style: solid !important;
                margin: 0 auto 0 0 !important;
                width: 100% !important
            }

            .r15-i {
                padding-top: 15px !important;
                text-align: left !important
            }

            .r16-i {
                background-color: #ffffff !important;
                padding-bottom: 20px !important;
                padding-left: 15px !important;
                padding-right: 15px !important;
                padding-top: 20px !important
            }

            .r17-i {
                padding-left: 0px !important;
                padding-right: 0px !important
            }

            .r18-o {
                border-style: solid !important;
                margin: 0 auto 0 auto !important;
                margin-bottom: 15px !important;
                margin-top: 15px !important;
                width: 100% !important
            }

            .r19-i {
                text-align: center !important
            }

            .r20-r {
                background-color: #7d00ff !important;
                border-radius: 8px !important;
                box-sizing: border-box;
                height: initial !important;
                padding-bottom: 12px !important;
                padding-top: 12px !important;
                text-align: center !important;
                width: 100% !important
            }

            .r21-o {
                background-size: cover !important;
                border-style: solid !important;
                margin: 0 auto 0 auto !important;
                width: 100% !important
            }

            .r22-i {
                background-color: #7d00ff !important;
                padding-bottom: 20px !important;
                padding-left: 15px !important;
                padding-right: 15px !important;
                padding-top: 20px !important
            }

            .r23-c {
                box-sizing: border-box !important;
                valign: top !important;
                width: 100% !important
            }

            .r24-c {
                box-sizing: border-box !important;
                text-align: center !important;
                width: 100% !important
            }

            .r25-c {
                box-sizing: border-box !important;
                width: 100% !important
            }

            .r26-i {
                font-size: 0px !important;
                padding-left: 67px !important;
                padding-right: 67px !important
            }

            .r27-c {
                box-sizing: border-box !important;
                width: 32px !important
            }

            .r28-o {
                border-style: solid !important;
                margin-right: 20px !important;
                width: 32px !important
            }

            body {
                -webkit-text-size-adjust: none
            }

            .nl2go-responsive-hide {
                display: none
            }

            .nl2go-body-table {
                min-width: unset !important
            }

            .mobshow {
                height: auto !important;
                overflow: visible !important;
                max-height: unset !important;
                visibility: visible !important
            }

            .resp-table {
                display: inline-table !important
            }

            .magic-resp {
                display: table-cell !important
            }
        }
    </style><!--[if !mso]><!-->
    <style type="text/css" emogrify="no">
        @import url("https://fonts.googleapis.com/css2?family=Montserrat");
    </style><!--<![endif]-->
    <style type="text/css">
        p,
        h1,
        h2,
        h3,
        h4,
        ol,
        ul,
        li {
            margin: 0;
        }

        a,
        a:link {
            color: #121214;
            text-decoration: none
        }

        .nl2go-default-textstyle {
            color: #3b3f44;
            font-family: verdana, geneva, sans-serif;
            font-size: 16px;
            line-height: 1.2;
            word-break: break-word
        }

        .default-button {
            color: #ffffff;
            font-family: verdana, geneva, sans-serif;
            font-size: 16px;
            font-style: normal;
            font-weight: normal;
            line-height: 1.15;
            text-decoration: none;
            word-break: break-word
        }

        .sib_class_16_white_roboto {
            color: #FFFFFF;
            font-family: verdana, geneva, sans-serif, Arial;
            font-size: 16px;
            word-break: break-word
        }

        .sib_class_16_black {
            color: #000000;
            font-family: verdana, geneva, sans-serif, Arial;
            font-size: 16px;
            word-break: break-word
        }

        .sib_class_16_white {
            color: #ffffff;
            font-family: verdana, geneva, sans-serif, Arial;
            font-size: 16px;
            word-break: break-word
        }

        .sib_class_16_black_sb {
            color: #000000;
            font-family: verdana, geneva, sans-serif, Arial;
            font-size: 16px;
            font-weight: 600;
            word-break: break-word
        }

        .sib_class_16_black_b {
            color: #000000;
            font-family: verdana, geneva, sans-serif, Arial;
            font-size: 16px;
            font-weight: 700;
            word-break: break-word
        }

        .sib_class_18_black_sb {
            color: #000000;
            font-family: verdana, geneva, sans-serif, Arial;
            font-size: 18px;
            font-weight: 600;
            word-break: break-word
        }

        .sib_class_18_blue_sb {
            color: #75EBEF;
            font-family: verdana, geneva, sans-serif, Arial;
            font-size: 18px;
            font-weight: 600;
            word-break: break-word
        }

        .sib_class_20_black_roboto {
            color: #000000;
            font-family: verdana, geneva, sans-serif, Arial;
            font-size: 20px;
            word-break: break-word
        }

        .sib_class_20_black_b {
            color: #000000;
            font-family: verdana, geneva, sans-serif, Arial;
            font-size: 20px;
            font-weight: 700;
            word-break: break-word
        }

        .sib_class_20_black_b_ul {
            color: #000000;
            font-family: verdana, geneva, sans-serif, Arial;
            font-size: 20px;
            font-weight: 700;
            text-decoration: underline;
            word-break: break-word
        }

        .sib_class_20_white_b_ul {
            color: #ffffff;
            font-family: verdana, geneva, sans-serif, Arial;
            font-size: 20px;
            font-weight: 700;
            text-decoration: underline;
            word-break: break-word
        }

        .sib_class_24_black_b {
            color: #000000;
            font-family: verdana, geneva, sans-serif, Arial;
            font-size: 24px;
            font-weight: 700;
            word-break: break-word
        }

        .sib_class_30_black_sb {
            color: #000000;
            font-family: verdana, geneva, sans-serif, Arial;
            font-size: 30px;
            font-weight: 600;
            word-break: break-word
        }

        .default-heading1 {
            color: #000000;
            font-family: verdana, geneva, sans-serif, Arial;
            font-size: 30px;
            word-break: break-word
        }

        .default-heading2 {
            color: #ffffff;
            font-family: verdana, geneva, sans-serif, Arial;
            font-size: 20px;
            word-break: break-word
        }

        .default-heading3 {
            color: #000000;
            font-family: verdana, geneva, sans-serif, Arial;
            font-size: 20px;
            word-break: break-word
        }

        .default-heading4 {
            color: #000000;
            font-family: verdana, geneva, sans-serif, Arial;
            font-size: 18px;
            word-break: break-word
        }

        a[x-apple-data-detectors] {
            color: inherit !important;
            text-decoration: inherit !important;
            font-size: inherit !important;
            font-family: inherit !important;
            font-weight: inherit !important;
            line-height: inherit !important;
        }

        .no-show-for-you {
            border: none;
            display: none;
            float: none;
            font-size: 0;
            height: 0;
            line-height: 0;
            max-height: 0;
            mso-hide: all;
            overflow: hidden;
            table-layout: fixed;
            visibility: hidden;
            width: 0;
        }
    </style>
    <!--[if mso]><xml> <o:OfficeDocumentSettings> <o:AllowPNG/> <o:PixelsPerInch>96</o:PixelsPerInch> </o:OfficeDocumentSettings> </xml><![endif]-->
    <style type="text/css">
        a:link {
            color: #121214;
            text-decoration: none;
        }
    </style>
</head>

<body bgcolor="#7d00ff" text="#3b3f44" link="#121214" yahoo="fix" style="background-color: #7d00ff;">
    <table cellspacing="0" cellpadding="0" border="0" role="presentation" class="nl2go-body-table" width="100%"
        style="background-color: #7d00ff; width: 100%;">
        <tr>
            <td>
                <table cellspacing="0" cellpadding="0" border="0" role="presentation" width="100%" align="center"
                    class="r0-o" style="table-layout: fixed; width: 100%;">
                    <tr>
                        <td valign="top" class="r1-i" style="background-color: transparent;">
                            <table cellspacing="0" cellpadding="0" border="0" role="presentation" width="600"
                                align="center" class="r3-o" style="table-layout: fixed;">
                                <tr>
                                    <td class="r4-i" style="padding-bottom: 5px; padding-top: 5px;">
                                        <table width="100%" cellspacing="0" cellpadding="0" border="0"
                                            role="presentation">
                                            <tr>
                                                <th width="100%" valign="top" class="r5-c" style="font-weight: normal;">
                                                    <table cellspacing="0" cellpadding="0" border="0"
                                                        role="presentation" width="100%" align="center" class="r0-o"
                                                        style="table-layout: fixed; width: 100%;">
                                                        <tr>
                                                            <td align="center" class="r7-i nl2go-default-textstyle"
                                                                style="color: #3b3f44; font-family: verdana,geneva,sans-serif; font-size: 16px; line-height: 1.2; word-break: break-word; padding-left: 30px; padding-right: 30px; padding-top: 20px; text-align: center;">
                                                                <div>
                                                                    <p style="margin: 0;"><a href="{{ mirror }}"
                                                                            style="color: #121214; text-decoration: none;"><span
                                                                                style="color: #ffffff; font-size: 12px;">Visualizar
                                                                                no navegador</span></a></p>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </th>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </table>
                <table cellspacing="0" cellpadding="0" border="0" role="presentation" width="600" align="center"
                    class="r3-o" style="table-layout: fixed; width: 600px;">
                    <tr>
                        <td valign="top" class="r8-i" style="background-color: #7d00ff;">
                            <table cellspacing="0" cellpadding="0" border="0" role="presentation" width="100%"
                                align="center" class="r0-o" style="table-layout: fixed; width: 100%;">
                                <tr>
                                    <td class="r10-i"
                                        style="background-color: #ffffff; padding-left: 35px; padding-right: 35px; padding-top: 35px;">
                                        <table width="100%" cellspacing="0" cellpadding="0" border="0"
                                            role="presentation">
                                            <tr>
                                                <th width="100%" valign="top" class="r5-c" style="font-weight: normal;">
                                                    <table cellspacing="0" cellpadding="0" border="0"
                                                        role="presentation" width="79" align="center" class="r0-o"
                                                        style="table-layout: fixed; width: 79px;">
                                                        <tr>
                                                            <td class="r11-i"
                                                                style="font-size: 0px; line-height: 0px; padding-bottom: 15px; padding-top: 15px;">
                                                                <img src="https://img.mailinblue.com/4853603/images/content_library/original/674dacf7bfc3dc71a1ff8f16.png"
                                                                    width="79" border="0"
                                                                    style="display: block; width: 100%;"></td>
                                                        </tr>
                                                    </table>
                                                    <table cellspacing="0" cellpadding="0" border="0"
                                                        role="presentation" width="100%" align="left" class="r12-o"
                                                        style="table-layout: fixed; width: 100%;">
                                                        <tr>
                                                            <td align="left" valign="top"
                                                                class="r13-i nl2go-default-textstyle"
                                                                style="color: #3b3f44; font-family: verdana,geneva,sans-serif; font-size: 16px; line-height: 1.2; word-break: break-word; text-align: left;">
                                                                <div>
                                                                    <h1 class="default-heading1"
                                                                        style="margin: 0; color: #000; font-family: verdana,geneva,sans-serif,Arial; font-size: 30px; word-break: break-word;">
                                                                         </h1>
                                                                    <h1 class="default-heading1"
                                                                        style="margin: 0; color: #000; font-family: verdana,geneva,sans-serif,Arial; font-size: 30px; word-break: break-word;">
                                                                        <span
                                                                            style="font-family: Verdana, geneva, sans-serif;">Olá
                                                                            #USER_NAME_INVITE,</span></h1>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                    <table cellspacing="0" cellpadding="0" border="0"
                                                        role="presentation" width="100%" align="left" class="r14-o"
                                                        style="table-layout: fixed; width: 100%;">
                                                        <tr>
                                                            <td align="left" valign="top"
                                                                class="r15-i nl2go-default-textstyle"
                                                                style="color: #3b3f44; font-family: verdana,geneva,sans-serif; font-size: 16px; line-height: 1.2; word-break: break-word; padding-top: 15px; text-align: left;">
                                                                <div>
                                                                    <div class="sib_class_20_black_roboto"
                                                                        style="color: #000; font-family: verdana,geneva,sans-serif,Arial; font-size: 20px; word-break: break-word;">
                                                                        <span
                                                                            style="font-family: Verdana, geneva, sans-serif;">Você
                                                                            foi convidado para fazer parte do projeto
                                                                            <strong>#PROJECT_NAME</strong> da Qazando
                                                                            Tools.</span><br><br><span
                                                                            style="font-family: Verdana, geneva, sans-serif;">Para
                                                                            aceitar o convite, clique no botão
                                                                            abaixo.</span></div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </th>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                            </table>
                            <table cellspacing="0" cellpadding="0" border="0" role="presentation" width="100%"
                                align="center" class="r0-o" style="table-layout: fixed; width: 100%;">
                                <tr>
                                    <td class="r16-i"
                                        style="background-color: #ffffff; padding-bottom: 20px; padding-top: 20px;">
                                        <table width="100%" cellspacing="0" cellpadding="0" border="0"
                                            role="presentation">
                                            <tr>
                                                <th width="100%" valign="top" class="r5-c" style="font-weight: normal;">
                                                    <table cellspacing="0" cellpadding="0" border="0"
                                                        role="presentation" width="100%" class="r6-o"
                                                        style="table-layout: fixed; width: 100%;">
                                                        <tr>
                                                            <td valign="top" class="r17-i"
                                                                style="padding-left: 15px; padding-right: 15px;">
                                                                <table width="100%" cellspacing="0" cellpadding="0"
                                                                    border="0" role="presentation">
                                                                    <tr>
                                                                        <td class="r9-c" align="center">
                                                                            <table cellspacing="0" cellpadding="0"
                                                                                border="0" role="presentation"
                                                                                width="285" class="r18-o"
                                                                                style="table-layout: fixed; width: 285px;">
                                                                                <tr class="nl2go-responsive-hide">
                                                                                    <td height="15"
                                                                                        style="font-size: 15px; line-height: 15px;">
                                                                                        ­</td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td height="18" align="center"
                                                                                        valign="top"
                                                                                        class="r19-i nl2go-default-textstyle"
                                                                                        style="color: #3b3f44; font-family: verdana,geneva,sans-serif; font-size: 16px; line-height: 1.2; word-break: break-word;">
                                                                                        <!--[if mso]> <v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" href="https://tool.qazando.com.br/" style="v-text-anchor:middle; height: 41px; width: 284px;" arcsize="20%" fillcolor="#7d00ff" strokecolor="#7d00ff" strokeweight="1px" data-btn="1"> <w:anchorlock> </w:anchorlock> <v:textbox inset="0,0,0,0"> <div style="display:none;"> <center class="default-button"><span>Acessar Qazando Tool</span></center> </div> </v:textbox> </v:roundrect> <![endif]-->
                                                                                        <!--[if !mso]><!-- --> <a
                                                                                            href="https://tool.qazando.com.br/"
                                                                                            class="r20-r default-button"
                                                                                            target="_blank"
                                                                                            title="Acessar Qazando Tool"
                                                                                            data-btn="1"
                                                                                            style="font-size: 16px; font-style: normal; font-weight: normal; line-height: 1.15; text-decoration: none; word-break: break-word; border-style: solid; word-wrap: break-word; display: block; -webkit-text-size-adjust: none; background-color: #7d00ff; border-bottom-width: 0px; border-color: #7d00ff; border-left-width: 0px; border-radius: 8px; border-right-width: 0px; border-top-width: 0px; color: #ffffff; font-family: verdana, geneva, sans-serif; height: 18px; mso-hide: all; padding-bottom: 12px; padding-top: 12px; width: 285px;">
                                                                                            <span>Acessar Qazando
                                                                                                Tool</span></a>
                                                                                        <!--<![endif]--> </td>
                                                                                </tr>
                                                                                <tr class="nl2go-responsive-hide">
                                                                                    <td height="15"
                                                                                        style="font-size: 15px; line-height: 15px;">
                                                                                        ­</td>
                                                                                </tr>
                                                                            </table>
                                                                        </td>
                                                                    </tr>
                                                                </table>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </th>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                            </table>
                            <table cellspacing="0" cellpadding="0" border="0" role="presentation" width="100%"
                                align="center" class="r21-o" style="table-layout: fixed; width: 100%;">
                                <tr>
                                    <td class="r22-i"
                                        style="background-color: #7d00ff; padding-bottom: 20px; padding-left: 35px; padding-right: 35px; padding-top: 20px;">
                                        <table width="100%" cellspacing="0" cellpadding="0" border="0"
                                            role="presentation">
                                            <tr>
                                                <th width="100%" valign="top" class="r23-c"
                                                    style="font-weight: normal;">
                                                    <table cellspacing="0" cellpadding="0" border="0"
                                                        role="presentation" width="530" align="center" class="r0-o"
                                                        style="table-layout: fixed; width: 530px;">
                                                        <tr>
                                                            <td valign="top">
                                                                <table width="100%" cellspacing="0" cellpadding="0"
                                                                    border="0" role="presentation">
                                                                    <tr>
                                                                        <td class="r25-c"
                                                                            style="display: inline-block;">
                                                                            <table cellspacing="0" cellpadding="0"
                                                                                border="0" role="presentation"
                                                                                width="530" class="r6-o"
                                                                                style="table-layout: fixed; width: 530px;">
                                                                                <tr>
                                                                                    <td class="r26-i"
                                                                                        style="padding-left: 187px; padding-right: 187px;">
                                                                                        <table width="100%"
                                                                                            cellspacing="0"
                                                                                            cellpadding="0" border="0"
                                                                                            role="presentation">
                                                                                            <tr>
                                                                                                <th width="52"
                                                                                                    class="r27-c mobshow resp-table"
                                                                                                    style="font-weight: normal;">
                                                                                                    <table
                                                                                                        cellspacing="0"
                                                                                                        cellpadding="0"
                                                                                                        border="0"
                                                                                                        role="presentation"
                                                                                                        width="100%"
                                                                                                        class="r28-o"
                                                                                                        style="table-layout: fixed; width: 100%;">
                                                                                                        <tr>
                                                                                                            <td class="r4-i"
                                                                                                                style="font-size: 0px; line-height: 0px; padding-bottom: 5px; padding-top: 5px;">
                                                                                                                <a href="https://www.instagram.com/qazando/"
                                                                                                                    target="_blank"
                                                                                                                    style="color: #121214; text-decoration: none;">
                                                                                                                    <img src="https://creative-assets.mailinblue.com/editor/social-icons/original_light/instagram_32px.png"
                                                                                                                        width="32"
                                                                                                                        border="0"
                                                                                                                        style="display: block; width: 100%;"></a>
                                                                                                            </td>
                                                                                                            <td class="nl2go-responsive-hide"
                                                                                                                width="20"
                                                                                                                style="font-size: 0px; line-height: 1px;">
                                                                                                                ­ </td>
                                                                                                        </tr>
                                                                                                    </table>
                                                                                                </th>
                                                                                                <th width="52"
                                                                                                    class="r27-c mobshow resp-table"
                                                                                                    style="font-weight: normal;">
                                                                                                    <table
                                                                                                        cellspacing="0"
                                                                                                        cellpadding="0"
                                                                                                        border="0"
                                                                                                        role="presentation"
                                                                                                        width="100%"
                                                                                                        class="r28-o"
                                                                                                        style="table-layout: fixed; width: 100%;">
                                                                                                        <tr>
                                                                                                            <td class="r4-i"
                                                                                                                style="font-size: 0px; line-height: 0px; padding-bottom: 5px; padding-top: 5px;">
                                                                                                                <a href="https://br.linkedin.com/company/qazando"
                                                                                                                    target="_blank"
                                                                                                                    style="color: #121214; text-decoration: none;">
                                                                                                                    <img src="https://creative-assets.mailinblue.com/editor/social-icons/original_light/linkedin_32px.png"
                                                                                                                        width="32"
                                                                                                                        border="0"
                                                                                                                        style="display: block; width: 100%;"></a>
                                                                                                            </td>
                                                                                                            <td class="nl2go-responsive-hide"
                                                                                                                width="20"
                                                                                                                style="font-size: 0px; line-height: 1px;">
                                                                                                                ­ </td>
                                                                                                        </tr>
                                                                                                    </table>
                                                                                                </th>
                                                                                                <th width="52"
                                                                                                    class="r27-c mobshow resp-table"
                                                                                                    style="font-weight: normal;">
                                                                                                    <table
                                                                                                        cellspacing="0"
                                                                                                        cellpadding="0"
                                                                                                        border="0"
                                                                                                        role="presentation"
                                                                                                        width="100%"
                                                                                                        class="r28-o"
                                                                                                        style="table-layout: fixed; width: 100%;">
                                                                                                        <tr>
                                                                                                            <td class="r4-i"
                                                                                                                style="font-size: 0px; line-height: 0px; padding-bottom: 5px; padding-top: 5px;">
                                                                                                                <a href="https://www.youtube.com/c/QAzando"
                                                                                                                    target="_blank"
                                                                                                                    style="color: #121214; text-decoration: none;">
                                                                                                                    <img src="https://creative-assets.mailinblue.com/editor/social-icons/original_light/youtube_32px.png"
                                                                                                                        width="32"
                                                                                                                        border="0"
                                                                                                                        style="display: block; width: 100%;"></a>
                                                                                                            </td>
                                                                                                            <td class="nl2go-responsive-hide"
                                                                                                                width="20"
                                                                                                                style="font-size: 0px; line-height: 1px;">
                                                                                                                ­ </td>
                                                                                                        </tr>
                                                                                                    </table>
                                                                                                </th>
                                                                                            </tr>
                                                                                        </table>
                                                                                    </td>
                                                                                </tr>
                                                                            </table>
                                                                        </td>
                                                                    </tr>
                                                                </table>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </th>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </table>
            </td>
        </tr>
    </table>
</body>

</html>`

export function getInviteEmail(currentProject: string, userName: string) {
    var result;
    result = html.toString().replace('#PROJECT_NAME', currentProject);
    result = result.toString().replace('#USER_NAME_INVITE', userName);
    return result
}
